export default __webpack_public_path__ + "static/media/close.340aa617.svg";